module.exports = __webpack_public_path__ + "img/accountCenter_bg_card.c3bd9212.svg";